// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 939) return "static/chunks/939-63abee94addb4dec.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"0c4e7b171677a652","2937":"5e6f1007026be5ab"}[chunkId] + ".js";
};